import { SETTING_TYPE, WIDGET_DISPLAY_CHOICE } from '@/constants/enum';
import { previewOptionSelector } from '@/redux/slice/preview.slice';
import { previewDateTimeSelector } from '@/redux/slice/previewDateTime.slice';
import { generalSettingSelector } from '@/redux/slice/setting.slice';
import { shippingSettingSelector } from '@/redux/slice/shipping.slice';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useRequiredMessage = () => {
  const generalSettings = useSelector(generalSettingSelector);
  const previewOptions = useSelector(previewOptionSelector);
  const shippingSettings = useSelector(shippingSettingSelector);
  const widgetSettings = useSelector(widgetSettingSelector);
  const {
    previewDateTime: { selectedDate, selectedTime },
  } = useSelector(previewDateTimeSelector);
  const isShowRequiredMessage = useMemo(() => {
    const notSelectDate =
      (previewOptions.methods.find((item) => item.selected)?.key === SETTING_TYPE.SHIPPING
        ? shippingSettings?.isActiveDatePicker
        : true) &&
      (!selectedDate || !selectedTime);

    const isDisabledButton =
      widgetSettings?.widgetPosition?.displayOnPage?.[0] === WIDGET_DISPLAY_CHOICE.CART
        ? generalSettings?.isDisableCheckoutButton
        : generalSettings?.isDisableAddToCartButton;
    return notSelectDate && isDisabledButton;
  }, [
    generalSettings?.isDisableAddToCartButton,
    generalSettings?.isDisableCheckoutButton,
    previewOptions.methods,
    selectedDate,
    selectedTime,
    shippingSettings?.isActiveDatePicker,
    widgetSettings?.widgetPosition?.displayOnPage,
  ]);

  return { isShowRequiredMessage };
};

export default useRequiredMessage;
